<template>
  <div>
    <div class="box" :class="miniPadding ? 'miniPadding' : ''">
      <div v-if="title" class="head">{{ title }}</div>
      <div class="con">
        <slot></slot>
      </div>
    </div>
  </div>
</template>
<style lang="less" scoped>
.box {
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.08);
  opacity: 1;
  border-radius: 8px;
  padding-top: 20px;
  padding-bottom: 20px;
  padding-left: 35px;
  padding-right: 25px;
  .head {
    margin-bottom: 20px;
    display: flex;
    align-items: center;
    padding-top: 12px;
    padding-bottom: 12px;
    padding-left: 16px;
    padding-right: 16px;
    background: rgba(240, 245, 247, 1);
    font-size: 12px;
    font-weight: bold;
    color: rgba(51, 51, 51, 1);
  }
}
// 小号的padding
.miniPadding {
  padding-top: 15px;
  padding-bottom: 15px;
}
</style>
<script>
export default {
  name: "Plan",
  props: {
    miniPadding: {
      default: false
    },
    title: {
      default: null,
      type: String
    }
  }
};
</script>
